<template>
  <v-card :class="{['bg-inner']: true, alerta}" :elevation="$$_elevacao">
    <v-card-title>
      <titulo-questao :numero="numero" :nome="detalhe.foqnome" :obrigatorio="detalhe.foqobrigatorio === 'S'" />
    </v-card-title>
    <v-card-subtitle>
      {{detalhe.foqdescricao}}
    </v-card-subtitle>
    <v-card-text>
      <v-radio-group v-model="value">
        <template v-for="item in detalhe.opcoes">
          <v-radio :label="item.fqodescricao"
          @mouseup.native="$_reset(item.id)"
          :value="item.id" :ref="item.id" :key="item.id"></v-radio>
        </template>
      </v-radio-group>

      <template v-if="(detalhe && detalhe.subquestoes && detalhe.subquestoes.length > 0) && !complemento">
        <template v-for="(subitem, index) in detalhe.subquestoes">
          <div :key="subitem.id">
            <v-divider></v-divider>
            <component
            :is="componenteCard(subitem.foqtipo)"
            :key="subitem.id"
            :ref="`subquestao-${index + 1}`"
            :detalhe="subitem"
            :complemento="true"
            >
            </component>
          </div>
        </template>
      </template>

    </v-card-text>
  </v-card>
</template>

<script>
import errorHandler from '../../utils/error-handler';
import { componenteCard } from '../../utils/tipo-card';
import TituloQuestao from '../TituloQuestao.vue';

export default {
  name: 'card-radio',

  components: {
    TituloQuestao,
  },

  data() {
    return {
      value: null,
      alerta: false,
    };
  },

  methods: {
    componenteCard,
    $_alerta() {
      this.alerta = true;
      errorHandler(`${this.$props.detalhe.foqnome} é obrigatória!`);
    },
    $_reset(id) {
      if (this.value === id) {
        setTimeout(() => {
          this.value = null;
        });
        // eslint-disable-next-line no-underscore-dangle
        this.$refs[id][0]._data.isActive = false;
      } else {
        this.value = id;
      }
      this.$nextTick(() => {});
    },
  },

  mounted() {
    if (this.detalhe.resposta) {
      const [res] = this.detalhe.resposta;
      this.value = res && res.forresposta;
    }
  },

  props: {
    // Ordem da questão no formulário (ex.: "1-2"), calculada pelo Checklist.
    // Subquestões (complemento) não recebem.
    numero: {
      type: String,
      default: null,
    },
    detalhe: Object,
    complemento: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value(valor) {
      if (valor) {
        this.alerta = false;
      }
    },
  },

  computed: {
    $$_elevacao() {
      return (this.$props.complemento) ? 5 : 0;
    },
  },
};
</script>

<style scoped>
  .bg-inner {
    width: 100%;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }

  .obrigatorio {
    color: red;
    padding-left: 5px;
  }

  .alerta {
    border: 1px solid red;
    animation: vibracao 0.5s;
  }

  @keyframes vibracao {
    0% { transform: translateX(10px); }
    25% { transform: translateX(-10px); }
    50% { transform: translateX(10px); }
    75% { transform: translateX(-10px); }
    100% { transform: translateX(0px); }
  }
</style>
